// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"65":"b205410f78285b49a914","154":"0a1d67bd4f497c6beb7c"}[chunkId] + ".css";
};